window.VH = window.VH === undefined ? {} : window.VH;
VH.SelectizeHelper = {
    formatterDate : function formatterDate(val) {
        let tVal = val === null ? '' : val,
            date = new Date((tVal).split(' ')[0] + 'T00:00:00.000Z');
        if (isNaN(date.valueOf())) {
            return '';
        }
        return (new Intl.DateTimeFormat('ru', {
            day:"2-digit",
            month:"2-digit",
            year:"numeric",
            timeZone: "UTC",
        })).format(date);
    },

    fillInfo : function fillInfo(selectInput, infoInput, optionsField, formatters)
    {
        optionsField = optionsField !== undefined ? optionsField : 'info';

        $(selectInput).on('change', function() {
            let _t = $(this),
                control = _t[0].selectize,
                item = control.options[_t.val()]
            ;
            if (item !== undefined) {
                $(infoInput)
                    .val(JSON.stringify(item[optionsField]))
                    .trigger('change');
            }
        });
    },

    fillItems : function fillItems(selectInput, inputItems, optionsField, formatters)
    {
        optionsField = optionsField !== undefined ? optionsField : 'info';
        formatters = formatters !== undefined ? formatters : {};
        $(selectInput).on('change', function() {
            let _t = $(this),
                control = _t[0].selectize,
                item = control.options[_t.val()]
            ;
            if (item !== undefined && item[optionsField] !== undefined) {
                let data = item[optionsField];
                for (const key in inputItems) {
                    let fieldId = inputItems[key],
                        val = data[key];
                    if (formatters[key] !== undefined) {
                        val = formatters[key](val);
                    }
                    $(fieldId)
                        .val(val === null ? '' : val)
                        .trigger('change')
                    ;
                }
            }
        });
    },

    registerLoad : function registerLoad(url)
    {
        return function (query, callback)
        {
            if (!query.length) return callback();
            $.getJSON(
                url,
                {
                    query: encodeURIComponent(query)
                },
                function (data) {
                    callback(data);
                }
            )
            .fail(function () {
                callback();
            });
        };
    },

    loadOptions : function loadOptions(elementSelector, val, url = null, selectVal=null, method = 'get', dependQueryParam = 'query')
    {
        let params = {},
            fnMethod = method === 'get' ? $.get : $.post,
            ss = $(elementSelector)
        ;
        if (url === null) {
            url = ss.data('selectize-url');
        }
        params[dependQueryParam] = val;
        fnMethod(url, params, function(data) {
            let control = ss[0].selectize;
            control.clear();
            control.clearOptions();
            if (data.length > 0) {
                control.addOption(data);
                control.enable();
                control.refreshOptions(false);
                if (selectVal !== null) {
                    control.addItem(selectVal, true);
                    ss.trigger('change');
                }
                if (ss.data('select-single') && data.length === 1) {
                    control.addItem(data[0].value, true);
                    ss.trigger('change');
                }
            } else {
                control.disable();
                control.refreshOptions(false);
            }
        }, 'JSON');
    },

    initDependUrl : function initDependUrl(elementSelector, dependSelector, dependQueryParam, url, method, getValueFunction)
    {
        let _t = VH.SelectizeHelper,
            ds = $(dependSelector)
        ;
        getValueFunction = getValueFunction !== undefined ? getValueFunction : function(element) {
            return element.val();
        };
        ds.on('change', function(){
            let selectVal = false;
            ds[0].dispatchEvent(new CustomEvent("sds_before_load"));
            if (ds.data('ds-default-value')) {
                selectVal = ds.data('ds-default-value');
            }
            _t.loadOptions(elementSelector, getValueFunction($(this)), url, selectVal, method, dependQueryParam);
        });
    },

    initDependOptions : function initDependOptions(elementSelector, dependSelector, dependOptionsParam)
    {
        let dependSelect = $(dependSelector),
            elementSelect = $(elementSelector),
            dependControl = dependSelect[0].selectize,
            elementControl = elementSelect[0].selectize
        ;

        dependSelect.on('change', function() {
            let options = dependControl.options[dependSelect.val()],
                items = (options !== undefined && options[dependOptionsParam] !== undefined) ? options[dependOptionsParam] : []
            ;

            elementControl.clear();
            elementControl.clearOptions();
            if (items.length > 0) {
                elementControl.addOption(items);
                elementControl.enable();
            } else {
                elementControl.disable();
            }
            elementControl.refreshOptions();
        });
    },

    init : function init(selector, options)
    {
        $(selector).selectize(options);
    }

};
